import '../../../utilities/ko.templates';
import '../../../utilities/ko-bindings/loading';
import { LoginViewModel }  from './LoginViewModel';
import { RegisterViewModel }  from './RegisterViewModel';

class LoginRegisterViewModel {
    constructor(parent, options) {
        BaseViewModel.call(this);
        var self = this;
        self.parent = parent;
        self.options = options;

        self.orderConfig = app.orderConfig;
        self.hasOrderConfig = _.isObject(self.orderConfig);


        // check if order login/register
        if (self.hasOrderConfig) {
            self.hasCurrentView = ko.observable(true);
            self.currentStepText = ko.observable("Lieferadresse");
            self.currentStep = ko.observable(1);
            self.steps = ko.computed(function () {
                var arr = [];
                // get available views
                var steps = self.orderConfig.orderSteps;
                var maxSteps = 5;
                if (self.orderConfig.orderSteps > maxSteps) {
                    steps = maxSteps;
                }

                for (var i = 0; i < steps - 1; i++) { 
                    var number = (i + 1);
                    arr.push({
                        number: number,
                        current: number === self.currentStep(),
                        clickable: false
                    });
                }
                return arr;
            });
        }

        self.Login = new LoginViewModel(self, {});
        self.Register = new RegisterViewModel(self, {});


        self.openRegistration = function () {

            self.Register.userName(self.Login.UserName());
            self.Register.password(self.Login.Password());
            window.document.title = 'Neu bei HeizOel24';

            self.ViewMode(1);
        };


        self.ViewMode = ko.observable(0);
        self.ViewMode.subscribe(function () {
            var step = "1";
            switch (self.ViewMode()) {
                case 0:
                    self.Login.isVisible(true);
                    self.Register.isVisible(false);
                    break;
                case 1:
                    self.Login.isVisible(false);
                    self.Register.isVisible(true);
                    step = self.Register.currentStep();
                    break;
            }
            _.delay(function () { M.updateTextFields(); }, 50);

            self.updateHash(self.ViewMode(), step);

        });

        self.updateHash = function (mode, step) {

            // if default view, delete hash
            if (mode == "0" && step == 1)
                hasher.setHash(null);
            else
                hasher.setHash(mode, step);
        };

        self._handleHashChange = function () {

            var array = hasher.getHashAsArray();
            if (_.isArray(array) && array.length > 1) {
                var mode = parseInt(array[0]);
                var step = parseInt(array[1]);
                self.ViewMode(mode);

                self.Register.setStep(step);
            } else {
                window.document.title = 'Anmelden';
                self.ViewMode(0);
            }

        };

        hasher.initialized.add(self._handleHashChange);
        hasher.changed.add(self._handleHashChange);
    }
}

ExtendViewModel(LoginRegisterViewModel, BaseViewModel);
app.rootViewModel().setViewModel(new LoginRegisterViewModel(app.rootViewModel(), {}));